import { query } from "./strapi";

export interface Media {
  id: number;
  url: string;
  alternativeText?: string;
  width?: number;
  height?: number;
  formats?: any;
}

export interface TitleTextImage {
  id: number;
  __component: "web-components.title-text-image";
  title: string;
  text: string;
}

export interface MemberImageInput {
  id: number;
  name: string;
  position: string;
  image?: { data: { attributes: Media } } | Media; // Support both possible shapes
}

export interface MembersImage {
  id: number;
  __component: "web-components.members-image";
  title: string;
  text: string;
  members: MemberImageInput[];
}

export interface GeneralMedia {
  id: number;
  __component: "general.media";
  media: {
    data: {
      attributes: Media;
    };
  };
}

export type DynamicZoneBlock = TitleTextImage | MembersImage | GeneralMedia;

export interface AboutData {
  title: string;
  tagline: string;
  blocks: DynamicZoneBlock[];
}

export async function getAboutData(): Promise<AboutData | null> {
  try {
    const response = await query("about");

    if (!response) {
      return null;
    }

    return {
      title: response.title,
      tagline: response.tagline,
      blocks: response.blocks || [],
    };
  } catch (error) {
    console.error("Error fetching About data:", error);
    return null;
  }
}

// Add an empty export to ensure this file is treated as a module
export {};
